
import { NavLink as RouterLink } from 'react-router-dom'
import { Typography } from '@mui/material'
import { Layout } from 'frame'
import PublicPageLayout from './public-page-layout'
import NotFoundImage from 'frame/assets/404.png'
import { themeV5 } from 'theme/v5'
import Box from '@mui/material/Box'

const Page404 = ({ withoutNav, publicPage }) => {

  const Page404Content = () => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          position: 'relative',
          marginTop: 40,
          padding: '20px',
          '@media(min-width: 400px)': {
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 100,
          },
        }}>
        <Box
          component="img"
          sx={{
            display: 'flex',
            width: '100%',
            maxWidth: '740px',
          }}
          src={NotFoundImage} alt="" />
        <Typography
          sx={{
            marginTop: '40px',
            marginBottom: '15px',
            color: themeV5.palette.text.primary,
            fontSize: 20,
            fontStyle: 'italic',
            '@media(min-width: 400px)': {
              fontSize: 40,
              textAlign: 'center',
            },
          }}
          gutterBottom variant="h1">
          Page Not Found
        </Typography>

        {!publicPage && (
          <>
            <Typography
              sx={{
                fontSize: '14px',
                '@media(min-width: 400px)': {
                  fontSize: '18px',
                  textAlign: 'center',
                },
              }}
              variant="body1">
              Try one of the sections below to find what you were after:
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                paddingTop: '20px',
                width: '100%',
                maxWidth: '400px',
                '@media(min-width: 400px)': {
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  maxWidth: '360px',
                },
              }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  margin: 0,
                  width: '100%',
                  '@media(min-width: 400px)': {
                    width: 'auto',
                    minWidth: '30%',
                  },
                }}>
                <RouterLink
                  sx={{
                    paddingY: '1.6px',
                    ...themeV5.typography.body1,
                    color: themeV5.palette.text.link,
                    fontSize: '14px',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                    '@media(min-width: 400px)': {
                      paddingY: '3.2px',
                      fontSize: '16px',
                    },
                  }}
                  to={'/dashboard'}>
                  Dashboard
                </RouterLink>
                <RouterLink
                  sx={{
                    paddingY: '1.6px',
                    ...themeV5.typography.body1,
                    color: themeV5.palette.text.link,
                    fontSize: '14px',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                    '@media(min-width: 400px)': {
                      paddingY: '3.2px',
                      fontSize: '16px',
                    },
                  }}
                  to={'/reports/fleet'}>
                  Reports
                </RouterLink>
                <RouterLink
                  sx={{
                    paddingY: '1.6px',
                    ...themeV5.typography.body1,
                    color: themeV5.palette.text.link,
                    fontSize: '14px',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                    '@media(min-width: 400px)': {
                      paddingY: '3.2px',
                      fontSize: '16px',
                    },
                  }}
                  to={'/contracts'}>
                  Contracts
                </RouterLink>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  margin: 0,
                  width: '100%',
                  '@media(min-width: 400px)': {
                    width: 'auto',
                    minWidth: '30%',
                  },
                }}>
                <RouterLink
                  sx={{
                    paddingY: '1.6px',
                    ...themeV5.typography.body1,
                    color: themeV5.palette.text.link,
                    fontSize: '14px',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                    '@media(min-width: 400px)': {
                      paddingY: '3.2px',
                      fontSize: '16px',
                    },
                  }}
                  to={'/drivers'}>
                  Drivers
                </RouterLink>
                <RouterLink
                  sx={{
                    paddingY: '1.6px',
                    ...themeV5.typography.body1,
                    color: themeV5.palette.text.link,
                    fontSize: '14px',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                    '@media(min-width: 400px)': {
                      paddingY: '3.2px',
                      fontSize: '16px',
                    },
                  }}
                  to={'/relief-vehicles'}>
                  Relief vehicle requests
                </RouterLink>
                <RouterLink
                  sx={{
                    paddingY: '1.6px',
                    ...themeV5.typography.body1,
                    color: themeV5.palette.text.link,
                    fontSize: '14px',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                    '@media(min-width: 400px)': {
                      paddingY: '3.2px',
                      fontSize: '16px',
                    },
                  }}
                  to={'/vehicle-relocations'}>
                  Vehicle relocation requests
                </RouterLink>
                <RouterLink
                  sx={{
                    paddingY: '1.6px',
                    ...themeV5.typography.body1,
                    color: themeV5.palette.text.link,
                    fontSize: '14px',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                    '@media(min-width: 400px)': {
                      paddingY: '3.2px',
                      fontSize: '16px',
                    },
                  }}
                  to={'/vehicle-summary'}>
                  Vehicle summary
                </RouterLink>
              </Box>
            </Box>
          </>
        )}
      </Box>
    </Box>
  )

  return publicPage ? (
    <PublicPageLayout>
      {Page404Content()}
    </PublicPageLayout>
  ) : !withoutNav ? (
    <Layout>
      {Page404Content()}
    </Layout>
  ) : Page404Content()
}

export default Page404
